import Column from "theme/layouts/Column";
import PropTypes from "prop-types";
import React from "react";
import SearchInput from "theme/components/search/SearchInput";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import { useSelector } from "react-redux";

const SearchHero = ({ query, location, t }) => {
    const heading = useSelector(({ page }) => page.data.heading?.heading) || {};
    const inputPlaceholder = useSelector(({ header }) => header?.data?.search?.input_placeholder_text) || "";

    return (
        <Column pb="12px" gap={["24px", null, null, null, "0"]}>
            <Wysiwyg
                data={heading?.text || t("search.results")}
                textComponent={(props) => (
                    <TextStyles textStyles={["Myriad Pro/14-100", null, null, null, "Myriad Pro/12-100"]} {...props} />
                )}
            />

            <SearchInput location={location} searchString={query} placeholderText={inputPlaceholder} />
        </Column>
    );
};

SearchHero.propTypes = {
    location: PropTypes.object.isRequired,
    query: PropTypes.string,
    t: PropTypes.func.isRequired,
};

SearchHero.defaultProps = {
    query: "",
};

export default SearchHero;
